<template>
  <div>
    <div class="container">
      <el-form label-position="left" label-width="90px" size="mini">
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="订单号">
              <el-input class="input-width" placeholder="请输入订单号" v-model="params.id"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="买家手机号">
              <el-input class="input-width" placeholder="请输入买家手机号" v-model="params.usermobile"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="下单时间">
              <el-date-picker v-model="params.time" :picker-options="pickerOptions" end-placeholder="结束日期" range-separator="至" start-placeholder="开始日期" type="daterange" unlink-panels></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-button size="small" @click="onClickFilter">筛选</el-button>
      <el-button style="color:#4E759E;" size="small" type="text" @click="onClickClearFilter">清空筛选条件</el-button>
    </div>
    <div class="container">
      <el-table :data="list">
        <el-table-column label="订单号" prop="id"></el-table-column>
        <el-table-column label="买家">
          <template slot-scope="scope">
            {{ scope.row.user.nickname }}({{ scope.row.user.mobile }})
          </template>
        </el-table-column>
        <el-table-column label="支付金额">
          <template slot-scope="scope">
            <span style="color:#ff4f4f">{{ scope.row.amount / 100 }}</span>
          </template>
        </el-table-column>
        <el-table-column label="支付时间">
          <template slot-scope="scope">
            {{ new Date(scope.row.paidat * 1000).toLocaleString() }}
          </template>
        </el-table-column>
      </el-table>
      <div v-if="list.length" class="table-bottom">
        <el-button v-if="hasMore" :loading="loadmore" @click="getOrders" size="small" type="primary">加载更多</el-button>
        <p v-else style="color: #ccc; font-size: 12px;">已加载全部，没有更多了</p>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { M } from '../../../service/grpc.js';
import { rpc } from '../../../service/index.js';
import { getToken } from '../../../service/helper.js';

const pickerOptions = {
  shortcuts: [
    {
      text: '最近一周',
      onClick(picker) {
        const end = new Date();
        const start = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
        picker.$emit('pick', [start, end]);
      }
    },
    {
      text: '最近一个月',
      onClick(picker) {
        const end = new Date();
        const start = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
        picker.$emit('pick', [start, end]);
      }
    }
  ]
};

export default {
  data() {
    return {
      token: getToken(),
      pickerOptions,
      params: {
        userid: 0,
        status: 2,
        idlessthan: 0,
        id: '',
        count: 20,
        createdatgreaterthan: 0,
        createdatlessthan: 0,

        usermobile: '',
        time: []
      },
      loadmore: false,
      hasMore: true,
      list: []
    };
  },
  created() {
    this.getList();
  },
  methods: {
    async getList() {
      this.loadmore = true;
      const { scrollY } = window;
      this.params.createdatgreaterthan = 0;
      this.params.createdatlessthan = 0;
      if (this.params.time.length === 2) {
        this.params.createdatgreaterthan = parseInt(this.params.time[0].getTime() / 1000);
        this.params.createdatlessthan = parseInt(this.params.time[1].getTime() / 1000);
      }
      // 根据手机号获取用户id
      if (this.params.usermobile) {
        const res = await rpc(
          'StoreUserService.GetUserList',
          M('UserListQueryRequest', {
            token: M('Token', { token: this.token }),
            mobile: this.params.usermobile,
            count: 1,
            order: 0
          })
        );
        if (!res.userlistList.length) {
          this.loadmore = false;
          this.hasMore = false;
          return;
        }
        this.params.userid = res.userlistList[0].id;
      }
      // 获取订单列表
      this.params.idlessthan = this.list.length ? this.list[this.list.length - 1].id : 0;
      const res = await rpc(
        'StoreFaceOrderService.GetFaceOrderList',
        M('FaceOrderListQueryRequest', {
          token: M('Token', { token: this.token }),
          ...this.params
        })
      );
      if (res.faceorderlistList.length === 0) {
        this.loadmore = false;
        this.hasMore = false;
        return;
      }
      // 完善订单列表里的关联资源
      const useridlist = res.faceorderlistList.map(item => item.userid);
      const res1 = await rpc(
        'StoreUserService.GetUserList',
        M('UserListQueryRequest', {
          token: M('Token', { token: this.token }),
          idlistList: useridlist,
          count: useridlist.length,
          order: 0
        })
      );
      res.faceorderlistList.forEach(item => {
        item.user = res1.userlistList.find(v => v.id === item.userid);
      });
      this.list = this.list.concat(res.faceorderlistList);
      this.hasMore = res.faceorderlistList.length;
      this.loadmore = false;
      if (this.params.idlessthan !== 0) {
        window.scroll(0, scrollY);
      }
    },
    onClickFilter() {
      this.list = [];
      this.getList();
    },
    onClickClearFilter() {
      this.params = {
        userid: 0,
        status: 2,
        idlessthan: 0,
        id: '',
        count: 20,
        createdatgreaterthan: 0,
        createdatlessthan: 0,

        usermobile: '',
        time: []
      };
      this.list = [];
      this.getList();
    }
  }
};
</script>

<style></style>
